import * as React from 'react'

function SvgIconEducation(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="education" aria-labelledby="t-education d-education">
        <title id="t-education">{'Education'}</title>
        <desc id="d-education">{'A square academic cap'}</desc>
        <path d="M31.4 11.1l-15-7c-.1-.1-.3-.1-.4-.1s-.3 0-.4.1l-15 7c-.4.2-.6.5-.6.9s.2.7.6.9l1.4.7v2.47c-.861.224-1.5 1-1.5 1.93a2 2 0 004 0c0-.93-.639-1.706-1.5-1.93V14l4.4 2.1C5.9 18 5 20.4 5 23c0 3.2 5.7 5 11 5s11-1.8 11-5c0-2.6-.9-5-2.4-6.9l6.9-3.2c.4-.2.6-.5.6-.9-.1-.4-.3-.7-.7-.9zM26 23c0 2.2-4.5 4-10 4S6 25.2 6 23c0-2.5.9-4.7 2.4-6.5l7.2 3.4c.1.1.3.1.4.1s.3 0 .4-.1l7.2-3.4c1.5 1.8 2.4 4 2.4 6.5zm-10-4L1 12l1.6-.7L16 12.5c.2 0 .5-.2.5-.5 0-.2-.2-.5-.5-.5L4.4 10.4 16 5l15 7-15 7z" />
      </g>
    </svg>
  )
}

export default SvgIconEducation
